module.exports = __webpack_public_path__ + "img/cow.6d2747cf.svg";